"use client";

import { useEffect, useRef } from "react";
import type { MutableRefObject } from "react";
import type { HomePageInteractionState } from "./domain/home-page/types";

export function useLatestInteractionState(
  interactionState: HomePageInteractionState,
): MutableRefObject<HomePageInteractionState> {
  const latestInteractionState = useRef(interactionState);

  useEffect(() => {
    latestInteractionState.current = interactionState;
  });

  return latestInteractionState;
}
